import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getDiffByPercent } from 'shared/helpers/getDiffPercent';

import { listForReplace } from './utils';

dayjs.extend(customParseFormat);

export class GeneralReportApiConverter {
  convertProviders = (data = [], previousData = []) => data
    // .filter(v => v.provider_name !== 'First')
    .map(item => {
      const previousItem = previousData?.find(v => v.provider_name === item.provider_name);

      return ({
        provider: listForReplace[item.provider_name?.toLowerCase()] ?? item.provider_name,
        betCount: this.convertItem('bet_count', item, previousItem),
        incomeAmount: this.convertItem('income', item, previousItem),
        betAmount: this.convertItem('bet', item, previousItem),
        winAmount: this.convertItem('won', item, previousItem),
        margin: this.convertItem('margin', item, previousItem),
      })
    });

  convertItem = (key, currentData, previousData) => {
    const current = currentData?.[key];
    const previous = previousData?.[key];
    const percent = getDiffByPercent({ current, previous });

    return ({
      current,
      previous,
      percent,
    })
  };

  convertDetails = (current = {}, previous = {}) => ({
    betCount: this.convertItem('bet_count', current, previous),
    betAmount: this.convertItem('bet', current, previous),
    winAmount: this.convertItem('won', current, previous),
    incomeAmount: this.convertItem('income', current, previous),
    margin: this.convertItem('margin', current, previous),
  });

  convertStatisticProvider = data => {
    return {
      providers: this.convertProviders(data.statistic_by_provider?.current_period, data.statistic_by_provider?.previous_period),
      details: this.convertDetails(data.total_providers_statistic?.current_period, data.total_providers_statistic?.previous_period),
    };
  };
}
